import React, { useMemo } from 'react';

import moment from 'moment';

import Table from '../../../../../Table';

export default function PaymentsTable({ payments, loanId }) {
  const cols = useMemo(
    () => [
      {
        title: 'Date',
        keys: ['_payment.date'],
        format: (value) => moment(value).format('M/D/YY'),
        link: (row) =>
          `/loans/${loanId}/payments/${row._payment.id}?tab=Payment`,
      },
      {
        title: 'Source',
        keys: ['_payment.source'],
      },
      {
        title: 'Amount',
        keys: ['_payment.amount'],
        type: 'currency',
      },
    ],
    [loanId]
  );

  return (
    <div>
      <Table cols={cols} rows={payments} title="Payments" />
    </div>
  );
}
